

export const GET_PARTICULAR_OWNER = "GET_PARTICULAR_OWNER"
export const GET_PARTICULAR_OWNER_SUCCESS = "GET_PARTICULAR_OWNER_SUCCESS"
export const GET_PARTICULAR_OWNER_FAIL = "GET_PARTICULAR_OWNER_FAIL"



export const ADD_PARTICULAR_OWNER = "ADD_PARTICULAR_OWNER"
export const ADD_PARTICULAR_OWNER_SUCCESS = "ADD_PARTICULAR_OWNER_SUCCESS"
export const ADD_PARTICULAR_OWNER_FAIL = "ADD_PARTICULAR_OWNER_FAIL"

export const UPDATE_PARTICULAR_OWNER = "UPDATE_PARTICULAR_OWNER"
export const UPDATE_PARTICULAR_OWNER_SUCCESS = "UPDATE_PARTICULAR_OWNER_SUCCESS"
export const UPDATE_PARTICULAR_OWNER_FAIL = "UPDATE_PARTICULAR_OWNER_FAIL"

export const GET_ALL_OWNER = "GET_ALL_OWNER"
export const GET_ALL_OWNER_SUCCESS = "GET_ALL_OWNER_SUCCESS"
export const GET_ALL_OWNER_FAIL = "GET_ALL_OWNER_FAIL"

export const GET_VIEW_COUNT_OWNER = "GET_VIEW_COUNT_OWNER"
export const GET_VIEW_COUNT_OWNER_SUCCESS = "GET_VIEW_COUNT_OWNER_SUCCESS"
export const GET_VIEW_COUNT_OWNER_FAIL = "GET_VIEW_COUNT_OWNER_FAIL"


export const LIKE_VIEW_OWNER = "LIKE_VIEW_OWNER"
export const LIKE_VIEW_OWNER_SUCCESS = "LIKE_VIEW_OWNER_SUCCESS"
export const LIKE_VIEW_OWNER_FAIL = "LIKE_VIEW_OWNER_FAIL"

export const GET_TOP_SALES = "GET_TOP_SALES"
export const GET_TOP_SALES_SUCCESS = "GET_TOP_SALES_SUCCESS"
export const GET_TOP_SALES_FAIL = "GET_TOP_SALES_FAIL"

